module.exports = __webpack_public_path__ + "static/media/Stellar Ark Single Headboard - 120 cm_Black.2d3c3809.png";